<template>
  <div 
    v-if="assort"
    class="d-flex align-items-end flex-column border rounded h-100 bg-white mb-2" 
    :class="itemLayout == 'horizontal' ? 'row' : ''"
  >
    <div
      class="inline_product clickable d-flex justify-content-center"
      :class="itemLayout == 'horizontal' ? 'w-25' : ''"
      style="cursor: pointer;background:#3b71de10;"
      :style="imageStyle"
    >
      <div class="d-flex justify-content-end for-dicount-div-null">
        <span class="for-discoutn-value-null"></span>
      </div>
      <div style="cursor: pointer;position: relative;">
        <div style="cursor: pointer;" @click="handleQuickView">
          <el-image 
            :src="imgProxy(product.image_url, rs='fill:250:250:1')"
            :alt="dt(product?.name_translations)"
            style="width: 100%; max-width: 250px"
            :style="imageStyle"
          >
            <template #error>
              <img src="/static/assets/front-end/img/image-place-holder.png" :alt="dt(product?.name_translations)" style="width: 100%;">
            </template>
          </el-image>
        </div>
        
        <el-button type="primary" plain circle class="btn-addon-plus" @click="handleQuickAddToCart">
          <i class="fa fa-plus fa-2x"></i>
        </el-button>
      </div>
    </div>
    <div
      class="single-product-details position-relative px-2"
      :class="itemLayout == 'horizontal' ? 'w-75' : ''"
      :style="contentStyle"
    >
      <el-button 
        type="info" 
        link
        class="text-left" 
        style="height: auto; 
        line-height: 1.3rem;" 
        @click="handleQuickView"
      >
        <span class="text-truncate-3">
          {{ dt(product.name_translations) }}
          - {{ dt(assort.name_translations) }}
        </span>
      </el-button>
      <el-tag v-if="dt(assort?.label_translations)" effect="dark">
        {{ dt(assort.label_translations) }}
      </el-tag>
    </div>
    <div class="mt-auto w-100 mb-2 px-2">
      <div v-if="product?.price_range" class="product-price text-center">
        <span class="text-accent">
            {{ t("products.salePrice") }} 
            {{ priceRange(product.price_range, "addon_price") }}
        </span>
        <template v-if="displayCoinReward">
          <br>
          <span class="text-warning">
              <img src="/static/images/coin.png" style="max-height: 30px" alt="owner_coin_reward">
              {{ priceRange(product.price_range, "owner_coin_reward", "", true) }}
          </span>
        </template>
      </div>
      <el-button type="primary" plain class="btn-block mt-2" @click="handleQuickAddToCart">
        加入
      </el-button>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { dataTranslations as dt, priceRange, imgProxy, currencyMap } from "../../utils"

const props = defineProps({
  product: Object,
  itemLayout: { type: String, default: "vertical" },
})
const emit = defineEmits(['ok', 'show'])

const { t, n, locale } = useI18n()
const displayCoinReward = computed(() => props.product?.display_coin_reward && props.product?.price_range?.min_owner_coin_reward > 0)
const currency = computed(() => aibTrackers?.currency)
const assort = computed(() => {
  if (props.product?.assorts !== undefined && props.product?.assorts.length > 0) {
    return props.product?.assorts[0]
  }
  return null
})
const contentStyle = computed(() => {
  if (props.itemLayout == "horizontal") {
    return {
      borderRadius: '0px 5px 5px 0px',
    }
  }
  return {
    // minHeight: displayCoinReward.value ? '180px' : '150px',
    // paddingTop: '10px',
    borderRadius: '0px 0px 5px 5px',
  }
})
const imageStyle = computed(() => {
  if (props.itemLayout == "horizontal") {
    return {
      borderRadius: '5px 0px 0px 5px',
    }
  }
  return {
    borderRadius: '5px 5px 0px 0px',
  }
})

const handleQuickAddToCart = async (item) => {
  emit("ok", props.product)
}

const handleQuickView = async () => {
  emit("show", props.product)
}
</script>

<style scoped>
.btn-addon-plus {
  position: absolute;
  z-index: 1;
  right: 0.2rem;
  bottom: 0.6rem;
  width: 2.5rem;
  height: 2.5rem;
  background: rgb(255 255 255 / 60%);
}
</style>
